// extracted by mini-css-extract-plugin
export default {"date":"LatestWeekTable_date__24j8s"};